import { Facade } from "./facade";
import { Loading, LoadingController } from "ionic-angular";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { TranslateService } from "@ngx-translate/core";
import { VasAppFacade } from "../../vas/services/vas-app-facade.service";
import { IAppFacade } from "../services/app-facade/app-facade.interface";
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';

export class LoadingFacade extends Facade {

    static readonly CLASS = "LoadingService";

    protected _loading: Loading;
    protected _isLoadingDisplayed: boolean = false;
    protected _isLoadingPresenting: boolean = false;
    protected _hideRequest = 0;
    protected _hideRequest$ = new BehaviorSubject(undefined);
    protected checkCloseRequestDelay = 250;

    constructor(
        protected appFacade: IAppFacade,
        protected loadingCtrl: LoadingController,
        protected translateService: TranslateService
    ) {
        super(appFacade);
    }

    showLoading$(message?, params?): Observable<any> {
        return fromPromise(this.showLoading(message, params));
    }

    showLoading(message?, params?): Promise<any> {

        message = this.contentMessage(message, params);

        if (this._loading) {
            this._loading.setContent(message);
            return Promise.resolve();
        }

        this._loading = this.loadingCtrl.create({
            content: message
        });

        return new Promise((resolve, reject) => {
            this._loading.present().then(
                () => {
                    resolve();
                },
                error => {
                    console.error(error);
                    resolve();
                }
            );
        });
    }

    updateContent(message?, params?): void {
        message = this.contentMessage(message, params);

        if (this._loading) {
            this._loading.setContent(message);
        }
    }

    hideLoading$(): Observable<any> {
        return fromPromise(this.hideLoading());
    }

    hideLoading(): Promise<any> {

        if (!this._loading) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            this._loading.dismiss().then(
                () => {
                    this._loading = undefined;
                    resolve();
                },
                error => {
                    console.error("error during loader: ", error);
                    resolve();
                }
            );
        });
    }

    protected contentMessage(message?, params?): string {
        message = message || "Please wait...";

        message = this.translateService.instant(message, params);

        return message;
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/loading-facade.ts